import React from "react";
import SearchAthleteTab from "../../common/athletes/SearchAthleteTab";

function UniversityAthletes() {
  return (
    <>
      <SearchAthleteTab />
    </>
  );
}

export default UniversityAthletes;
